import { API_CONTAGENS_ESTOQUE } from '../api/apiConfig';
import { ContagemEstoqueDiaria } from '../types/estoque';
import { createCrudService } from './crudFactory';

export const contagensEstoqueService =
  createCrudService<ContagemEstoqueDiaria>(API_CONTAGENS_ESTOQUE);
